import * as actionTypes from 'web-app/react/constants/action-types';
import {createAction} from 'web-app/util/redux/typed-action-helpers';
import {type AppModule} from 'web-app/util/graphql/api-types';

import type * as Types from './types';
import type FileRecord from './file-record';

interface FileUploadConfig {
    uploadImagesAsFile?: boolean;
    imageFor?: string;
    type?: string;
    taggingAppModule?: AppModule;
}

export const {action: addFile} = createAction(
    actionTypes.FILE_UPLOAD_ADD_FILE,
    (formName: string, file: File, config?: FileUploadConfig) => ({
        formName,
        file,
        config,
    }),
);

export const {action: removeFile} = createAction(
    actionTypes.FILE_UPLOAD_REMOVE_FILE,
    (formName: string, file: FileRecord, taggingAppModule: string | null) => ({
        formName,
        file,
        taggingAppModule,
    }),
);

export const {action: filePersistSuccess} = createAction(
    actionTypes.FILE_UPLOAD_FILE_PERSIST_SUCCESS,
    (formName: string, file: File, persistedFile: Types.PersistedObject, config?: FileUploadConfig) => ({
        formName,
        file,
        persistedFile,
        config,
    }),
);
